import React, { useState, useRef } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Turnstile } from '@marsidev/react-turnstile';
import { login } from '../../services/authService';
import './Login.scss';

const Login = () => {
  const navigate = useNavigate();
  const turnstileRef = useRef(null);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [turnstileToken, setTurnstileToken] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || '1x00000000000000000000AA';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (siteKey && !turnstileToken) {
      setError('Lütfen güvenlik doğrulamasını tamamlayınız.');
      return;
    }

    setIsLoading(true);

    try {
      const response = await login(formData.email, formData.password, turnstileToken);

      if (response.isSuccess) {
        navigate('/dashboard');
      } else {
        setError(response.resultMessage || response.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
        turnstileRef.current?.reset();
        setTurnstileToken('');
      }
    } catch (error) {
      setError('Bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
      console.error('Login error:', error);
      turnstileRef.current?.reset();
      setTurnstileToken('');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>
            <div className="login-form">
              <div className="text-center">
                <img src="/Logo.png" alt="İBB Logo" className="login-logo" />
              </div>
              <Form onSubmit={handleSubmit}>
                {error && <Alert variant="danger">{error}</Alert>}

                <Form.Group className="mb-4">
                  <Form.Label>E-posta / Kullanıcı Adı</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="E-posta veya Kullanıcı Adınızı giriniz"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Şifre</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Şifrenizi giriniz"
                    required
                  />
                </Form.Group>

                <div className="d-flex justify-content-center mb-4">
                  <Turnstile
                    ref={turnstileRef}
                    siteKey={siteKey}
                    onSuccess={(token) => setTurnstileToken(token)}
                    onError={() => setTurnstileToken('')}
                    onExpire={() => setTurnstileToken('')}
                  />
                </div>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={isLoading}
                >
                  {isLoading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;

